export const getAPLoanReducer = (state) => {
  return state.aploanReducer;
};

export const getAPLoanAccountId = (state) => {
    console.log("selector",state.aploanReducer,state.aploanReducer.data.nrocuenta)
  return (
    (state &&
      state.aploanReducer &&
      state.aploanReducer.data &&
      state.aploanReducer.data.nrocuenta) ||
    undefined
  );
};
